// Toast.js
import React from 'react';

const Toast = ({ message, onClose }) => {
  return (
    <div style={{
      position: 'fixed',
      top: '20px', // Changed from bottom to top
      right: '20px',
      padding: '15px 40px',
      backgroundColor: '#4BB543',
      color: 'white',
      borderRadius: '5px',
      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
      zIndex: 1000000,
    }}>
      <span>{message}</span>
      <button onClick={onClose} style={{
        marginLeft: '15px',
        background: 'none',
        border: 'none',
        color: 'white',
        fontWeight: 'bold',
        cursor: 'pointer',
      }}>
        ✖
      </button>
    </div>
  );
};

export default Toast;
